<template>
  <div>
    <el-dialog
      title="分享活动"
      :visible.sync="showDialog"
      width="50%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="cancelAction"
    >
      <el-main>
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          label-width="180px"
        >
          <el-form-item>
            <span slot="label">
              <el-tooltip
                class="item"
                effect="dark"
                content="用于活动数据统计，可不填"
                placement="top"
              >
                <i class="el-icon-question" />
              </el-tooltip>
              渠道参配置：
            </span>
            <el-input
              v-model="form.channel_form"
              placeholder="请输入渠道参，支持字母、数字、_（下划线），可不填"
            />
          </el-form-item>

          <el-form-item label="分享二维码">
            <el-button
              type="primary"
              icon="el-icon-download"
            >
              生成并下载二维码
            </el-button>
          </el-form-item>
          <el-form-item label="分享链接">
            <div>
              <el-button
                type="primary"
                icon="el-icon-document-copy"
              >
                复制分享链接
              </el-button>
            </div>
            <div>
              <el-input
                v-model="form.share_link"
                type="textarea"
                autosize
                placeholder="请输入内容"
              />
            </div>
          </el-form-item>
        </el-form>
      </el-main>
      <el-footer>
        <el-button @click="cancelAction">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >
          确定
        </el-button>
      </el-footer>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ShareActivity',
  props: {
    shareActivityVisible: {
      type: Boolean,
      default: false
    },
    shareActivityData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data () {
    return {
      list: [
        { id: 1, name: '模版1' },
        { id: 2, name: '模版2' },
        { id: 3, name: '模版3' },
        { id: 4, name: '模版4' }
      ],
      codeList: [
        { id: 1, name: '活码名称1' },
        { id: 2, name: '活码名称2' },
        { id: 3, name: '活码名称3' },
        { id: 4, name: '活码名称4' }
      ],
      options: [],
      codeOptions: [],
      form: {
        channel_form: '',
        share_link: ''
      },
      rules: {
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    showDialog () {
      return this.shareActivityVisible
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        this.selectValue = this.shareActivityData
      } else {
        this.selectValue = []
      }
    }
  },
  created () {
    this.options = this.list
    this.codeOptions = this.codeList
  },
  methods: {
    // 关闭模态框
    cancelAction () {
      this.$emit('shareActivityVisibleChange', [false])
    },
    async handleConfirm () {
      let params = this.form
      params.activity_id = this.selectValue[1].item.activity_id
      console.log(params)
      const data = await this.$api.formActivity.shareSettingFormsActivity(params)
      if (data.status === true) {
        this.$message({
          message: '分享成功',
          type: 'success'
        })
        this.$emit('shareActivityVisibleChange', [false, params])
      }
    },
    remoteMethod (query) {
      if (query !== '') {
        this.options = this.list.filter((item) => {
          return item.name.indexOf(query) > -1
        })
      } else {
        this.options = this.list
      }
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    remoteCodeMethod (query) {
      if (query !== '') {
        this.codeOptions = this.codeList.filter((item) => {
          return item.name.indexOf(query) > -1
        })
      } else {
        this.codeOptions = this.codeList
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}
</style>
